import React, { createContext, Dispatch, useReducer } from "react";
import { GlobalAction, InitialStateType } from "@context/types";
import { mainReducer } from "@context/reducers";

const initialState: InitialStateType = {
  data: {
    name: null,
    lastname: null,
    docType: null,
    document: null,
    minorityId: null,
    birthday: null,
    epsId: null,
    areas: [],
  },
  patient: {
    country: "",
    state: "",
    city: "",
    streetName: null,
    neighborhood: null,
    address: null,
    addressDetail: null,
    phone: null,
    email: null,
    means: null,
    natural: {
      name: null,
      lastName: null,
      bond: null,
      docType: null,
      documemt: null,
      relationshipType: null,
      relationship: null,
    },
    legal: { entity: null, entityType: null },
  },
  describe: {
    detail: null,
  },
  islegal: false,
  page: 0,
  anonymous: false,
  loading: false,
};
const AppContext = createContext<{
  state: InitialStateType;
  dispatch: Dispatch<GlobalAction>;
}>({
  state: initialState,
  dispatch: () => null,
});

const AppProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(mainReducer, initialState);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
};

export { AppProvider, AppContext };
/*
* const optionInitial = {
  value: null,
  label: null,
};
const initialState: InitialStateType = {
  data: {
    name: null,
    lastname: "",
    docType: optionInitial,
    document: "",
    minorityId: optionInitial,
    birthday: "",
    epsId: optionInitial,
    areas: [],
  },
  patient: {
    country: optionInitial,
    state: optionInitial,
    city: optionInitial,
    streetName: optionInitial,
    neighborhood: "",
    address: "",
    addressDetail: "",
    phone: "",
    email: "",
    means: optionInitial,
    natural: {
      name: "",
      lastName: "",
      bond: optionInitial,
      docType: optionInitial,
      documemt: "",
      relationshipType: "",
      relationship: "",
    },
    legal: { entity: "", entityType: "" },
  },
  describe: {
    detail: "",
  },
  islegal: false,
  page: 0,

* */
